import { FormControl, Input, MenuItem, Select } from '@material-ui/core';
import * as React from 'react';
import { FlaggedEmailAccount } from '../graphql/queries/home';

interface FlaggedEmailAccountSelectorProps {
    selected: string;
    accounts: FlaggedEmailAccount[];
    onSelectAnotherAccount: (account: string) => void;
}

export class FlaggedEmailAccountSelector extends React.Component<FlaggedEmailAccountSelectorProps> {
    handleAccountSelect = (event: React.ChangeEvent<{ value: unknown }>) => {
        const account = event.target.value as string;
        if (this.props.selected !== account) {
            this.props.onSelectAnotherAccount(account);
        }
    };

    render() {
        const { accounts, selected } = this.props;
        if (!accounts) return null;
        const sortedAccounts = accounts.slice(0).sort((s1, s2) => s1.name.localeCompare(s2.name));
        const renderAccountValue = (accountValue: string) => {
            const accountInfo = sortedAccounts.find((a) => a.account === accountValue);
            if (!accountInfo) {
                return accountValue;
            }
            return (
                <div style={{ display: 'flex', justifyContent: 'space-between', color: 'white' }}>
                    <div>{accountInfo.account}</div>
                    <div style={{ marginLeft: '20px' }}>[{accountInfo.count}]</div>
                </div>
            );
        };
        const menuItems = sortedAccounts.map(({ count, account }) => (
            <MenuItem value={account} key={account}>
                <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                    <div>{account}</div>
                    <div style={{ marginLeft: '20px' }}>[{count}]</div>
                </div>
            </MenuItem>
        ));
        const renderValueFn = (value: unknown) => renderAccountValue(value as string);
        return (
            <div className="email-inbox-account-info">
                <FormControl>
                    <Select
                        value={selected}
                        onChange={this.handleAccountSelect}
                        autoWidth={true}
                        input={<Input disableUnderline={true} />}
                        renderValue={renderValueFn}
                        style={{ width: 'auto' }}
                    >
                        {menuItems}
                    </Select>
                </FormControl>
            </div>
        );
    }
}
